export default ['en', {

    "rtl": false,
    "two_letter_iso_name": "en",
    "iso_name": "en-US",
    "strong_side": "left",
    "weak_side": "right",
    "google_lang_code": "en",

    "activity_indicator": {
        "loading": "Loading...",
        "saving": "Saving...",
        "removing": "Removing...",
        "deleting": "Deleting",
        "loggingin": "Logging in...",
        "loggingout": "Logging out...",
        "force_logging_out": "Forcing log out...",
        "nextcontact": "Looking for next contact...",
        "starting_break": "Starting break...",
        "stopping_break": "Stopping break...",
        "starting_live_listening": "Starting live listening...",
        "starting_live_screen_monitor": "Starting live screen monitor..."
    },

    "size_abbrs": {
        "b": "Bytes",
        "kb": "KB",
        "mb": "MB",
        "gb": "GB",
        "tb": "TB"
    },

    'calendar': {
        'weekdays': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        'weekdays_short': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        'weekdays_very_short': ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        'months': ['January','February','March','April','May','June','July','August','September','October','November','December'],
        'months_short': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        'today': 'Today',
        'close': 'Close'
    },

    "date_formats": {
        "normal_date": "dd/MM/yy",
        "short_time": "H:mm",
        "normal_date_short_time": "dd/MM/yy H:mm",
        "not_defined": "Not defined"
    },
    "error_codes": {
        "400": "An invalid request was sent to the server. Please contact your administrator, or try again.",
        "401": "You must be loggen on to perform this action.",
        "402": "This action was rejected by the server due to pending payments.",
        "403": "You are not authorized to perform this action.",
        "404": "The resource you requested does not exist.",
        "405": "An invalid request was sent to the server. Please contact your administrator, or try again.",
        "500": "An internal server error occurred. Please contact your administrator, or try again.",
        "501": "An unknown request has been sent to the server. Please contact your administrator, or try again.",
        "502": "Looks like you are using a failed proxy server. Please contact your administrator, or try again.",
        "503": "The service is currently unavailable. Please contact your administrator, or try again.",
        "504": "Looks like you are using a failed proxy server. Please contact your administrator, or try again.",
        "not-found": "The resource you requested does not exist.",
        "not-allowed": "You are not authorized to perform this action.",
        "authorization-error": "You must be logged on to perform this action.",
        "invalid-email": "The provided email address is invalid.",
        "username-in-use": "The username provided is already in use.",
        "email-in-use": "The email address provided is already in use.",
        "empty-file": "The uploaded file is an empty file.",
        "ami-trouble": "PBX error, please contact your system administrator.",
        "403-no-match": "Username or password does not match.",
        "403-locked": "Your account is locked. Please contact your administrator.",
        "default": "An unknown error occurred. Please contact your administrator, or try again."
    },
    "filters": {
        "add_filter": "Add filter",
        "name": "Name",
        "manager": "Manager",
        "is_active": "Is active?",
        "created_at": "Created at",
        "updated_at": "Updated at",
        "assigned_at": "Assigned at",
        "email_address": "Email",
        "project": "Project",
        "product": "Product",
        "campaign": "Campaign",
        "team_heads": "Team heads",
        "idt": "ID num",
        "first_name": "First name",
        "last_name": "Last name",
        "role": "Role",
        "username": "Username",
        "phone_extension": "Phone extension",
        "job_start": "Job start",
        "description": "Description",
        "from_email": "From email",
        "last_status_change": "Last status change",
        "start_date": "Start date",
        "end_date": "End date",
        "end_reason": "End reason",
        "continue_reason": "Continue reason",
        "team": "Team",
        "user": "User",
        "user_representative": "Agent",
        "date": "Date",
        "lead_provider_user_team": "Lead provider team",
        "assigned_to": "Assigned to agent",
        "next_action": "Next action"
    },
    "filter_condition": {
        "=": "Equal to",
        ">": "Bigger than",
        "<": "Smaller than",
        "!=": "Different than",
        ">=": "Bigger or equal to",
        "<=": "Smaller or equal to",
        "<>": "Between",
        "-24:0H": "Last 24 hours",
        "0:1d": "Today",
        "-1:0d": "Yesterday",
        "-6:1d": "Last 7 days",
        "-29:1d": "Last 30 days",
        "0:1w": "Current week",
        "-1:0w": "Last week",
        "0:1m": "Current month",
        "-1:0m": "Last month"
    },
    "filter_condition_order": [
        '0:1d', '-1:0d',
        '0:1w', '-1:0w',
        '0:1m', '-1:0m',
        '-24:0H',
        '-6:1d', '-29:1d',
        '=', '>', '<', '!=', '>=', '<=','<>'
    ],
    "filter_date_options": {
        "today": "Today",
        "yesterday": "Yesterday"
    },
    "filter_option_no_campaign": "No campaign",
    "filter_option_any_campaign": "Any campaign",
    "export_options": {
        "csv": "CSV",
        "xml": "XML"
    },
    "main_nav": {
        "welcome_male": "Welcome <br/>{{name}}!",
        "welcome_female": "Welcome <br/>{{name}}!",
        "welcome": "Welcome <br/>{{name}}!",
        "leads": "Leads",
        "realtime": "Real time",
        "reports": "Reports",
        "management": "Management",
        "recordings": "Recordings",
        "logout": "Logout"
    },
    "side_nav": {
        "managements": {
            "settings": "Settings",
            "projects": "Projects",
            "roles": "Roles",
            "teams": "Teams",
            "users": "Users",
            "lead_providers": "Leads providers",
            "general": "General"
        },
        "reports": {
            "pick_report_message": "Pick a report from side menu",
            "call_events": "Events report",
            "realtime_userinfo": "Realtime agents",
            "userinfo": "Agents report",
            "call_history": "Call history reports",
            "orders": "Orders report"
        },
        "leads": {
            "assign": "Assign leads",
            "manual_entry": "Manual lead entry"
        }
    },
    "login": {
        "title": "Login",
        "extension_title": "Extension",
        "username": "Username:",
        "password": "Password:",
        "submit": "Submit >"
    },
    "order_statuses": {
        "open": "Open",
        "closed": "Closed"
    },
    "call_types": {
        "outgoing": "Outgoing",
        "initiated": "Initiated",
        'predictive': 'Predictive Dialer',
        'incoming': 'Incoming',
        "override": "Override"
    },
    "call_actions": {
        "continue": "Call back",
        "end": "End process"
    },
    "call_history_statuses": {
        "dialing": "Dialing",
        "answered": "Answered",
        "busy": "Busy",
        "noanswer": "No answer",
        "denied": "Denied",
        "failed": "Failed",
        "cancelled": "Cancelled",
        'abandoned': 'Abandoned'
    },
    "contact_fields": {
        "section_basic": "General",
        "section_contact": "Contact details",
        "section_comments": "Notes",
        "section_more": "More fields",
        "title": "Title",
        "gender": "Gender",
        "idt": "ID num",
        "first_name": "First name",
        "last_name": "Last name",
        "company": "Company",
        "website_url": "Website",
        "birthdate": "Birth date",
        "phone": "Phone",
        "phone2": "Phone 2",
        "phone3": "Phone 3",
        "phone4": "Phone 4",
        "fax": "Fax",
        "email": "Email",
        "comment": "Notes",
        "address_country": "Address - Country",
        "address_state": "Address - State",
        "address_city": "Address - City",
        "address_street": "Address - Street",
        "address_street_number": "Address - House number",
        "address_postal_code": "Address - Zip code",
        "address2_country": "Address 2 - Country",
        "address2_state": "Address 2 - Country",
        "address2_city": "Address 2 - City",
        "address2_street": "Address 2 - Street",
        "address2_street_number": "Address 2 - House no",
        "address2_postal_code": "Address 2 - Zip code",
        "address": "Address",
        "address2": "Additional address",
        "country": "Country",
        "state": "State",
        "city": "City",
        "street": "Street",
        "street_number": "House no",
        "postal_code": "Zip code",
        "assign_to_campaign": "Assign to campaign",
        "campaign_next_action": {
            "call": "Waiting for first action",
            "continue": "In process",
            "end": "End process"
        }
    },
    "genders": {
        "male": "Male",
        "female": "Female"
    },
    "order_fields": {
        "id": "Order ID",
        "product_id": "Product ID",
        "campaign_id": "Campaign ID",
        "contact_id": "Contact",
        "status": "Order status",
        "created_at": "Created at",
        "created_by": "Created by",
        "updated_at": "Updated at",
        "closed_at": "Closed at",
        "closed_by": "Closed by"
    },
    "general_settings": {
        "title": "General settings",
        "tab_projects": {
            "title": "Projects",
            "continue_reasons": "Call back reasons",
            "end_reasons": "End process reasons"
        },
        "tab_calls": {
            "title": "Calls"
        }
    },
    "projects_list": {
        "title": "Projects list",
        "new_project": "New project",
        "general_settings": "General settings",
        "columns": {
            "id": "ID",
            "name": "Name",
            "manager": "Project manager",
            "is_active": "Is active?",
            "created_at": "Created at",
            "updated_at": "Updated at",
            "actions": "Actions"
        },
        "delete_project_prompt": "Are you sure you want to delete the project?\nThis action will delete all the associated data, campaigns, contact, etc..."
    },
    "recordings_list": {
        "title": "Recordings",
        "columns": {
            "calldate": "Call date",
            "uniqueid": "Unique Id",
            "destination": "Phone number",
            "channel": "Extension",
            "total_duration": "Total duration",
            "call_duration": "Neto duration",
            "disposition": "Disposition",
            "did": "Incoming number",
            "actions": "Actions"
        },
        "disposition_options": {
            "NO ANSWER": "No answer",
            "ANSWERED": "Answered",
            "BUSY": "Busy",
            "CONGESTION": "Congestion"
        }
    },
    "project_tabbed_area": {
        "project_list": "Project list",
        "edit_title": "Edit project",
        "new_title": "New project",
        "general": "General",
        "products": "Products",
        "campaigns": "Campaigns",
        "users": "Agents",
        "contacts": "Contacts and import",
        "general_side_menu": {
            "general": "General settings",
            "continue_reasons": "Call back reasons",
            "end_reasons": "End process reasons",
            "contact_custom_fields": "Contact custom fields",
            "realtime_users_settings": "Realtime settings",
            'advanced_settings': 'Advanced settings'
        },
        "product_side_menu": {
            "basic": "Settings",
            "order_custom_fields": "Order custom fields"
        },
        "campaign_side_menu": {
            "basic": "Settings",
            "time_table": "Work time table",
            "call_settings": "Call settings",
            "users": "Agents"
        }
    },
    "project_details": {
        "title": "General settings",
        "project_name": "Project name:",
        "project_status": "Project status:",
        "project_mode": "Project mode:",
        "project_manager": "Project manager:",
        "project_teams": "Project teams:",
        "project_teams_and_heads": "Project teams and teams head:",
        "new_contact_default_campaign": "Default campaign for new contact:",
        "can_user_choose_new_contact_campaign": "Allow agent to select campaign for new contact:",
        'hide_continue_by_selection': 'Hide the "return by" selection',
        'select_unique_field': 'Select unique field for duplicate checks',
        "add_team_button": "Add new team",
        "team_name": "Team name",
        "team_managers": "Team managers",
        "project_statuses": {
            "active": "Active",
            "inactive": "Inactive"
        },
        "project_modes": {
            "internal": "Internal",
            'predictive': 'Internal - Predictive Dialer',
            "external": "External"
        },
        "saved_prompt": "Project saved successfully ",
        "default_campaign_error_prompt": "Default campaign must be selected\nor selecting by agent should be allowed"
    },
    "project_realtime_settings": {
        "title": "Realtime settings",
        "idle_duration_alert_minutes": "Idle duration alert after:",
        "in_call_duration_alert_minutes": "In call alert after:",
        "dialing_duration_alert_minutes": "Dialing alert after:",
        "logged_in_duration_alert_minutes": "Logged in alert after:",
        "saved_prompt": "Saved successfully"
    },

    'project_advanced_settings': {
        'title': 'Advanced Settings',

        'hide_mapped_continue_reasons': 'Hide mapped callback reasons:',
        'hide_mapped_end_reasons': 'Hide mapped end reasons:',
        'lock_continue_reason_id': 'Lock callback reason:',
        'lock_end_reason_id': 'Lock end reason:',
        'custom_fields_to_display': 'Custom fields to display on agent outgoing:',
        'open_website_url': 'Open contact url each time:',
        'option_no_lock': 'No lock',

        'saved_prompt': 'Settings saved successfully',
    },

    "campaign_edit": {
        "basic": {
            "title": "General settings",
            "campaign_name": "Campaign name:",
            "campaign_external_id": "Campaign external ID:",
            "campaign_description": "Campaign description:",
            "campaign_status": "Campaign status:",
            "campaign_mode": "Campaign mode:",
            "campaign_priority": "Priority: <sup>Higher value gets higher priority</sup>",
            "campaign_exclusive": "Exclusive:",
            "duplicate": "Duplicate campaign",
            "new": "New campaign",
            "saved_prompt": "Campaign saved successfully"
        },
        "call_settings": {
            "title": "Call settings",
            "redial_on_noresponse_minutes": "Callback on no response after:",
            "redial_on_busy_minutes": "Callback on busy after:",
            "redial_count": "Callback times in case of busy / no answer",
            "saved_prompt": "Campaign saved successfully"
        },
        "timetable": {
            "title": "Work times",
            "timetable_always": "Always active",
            "day": "Day",
            "from_time": "Start",
            "to_time": "End",
            "select_time": "Select time",
            "day_names": {
                "1": "Sunday",
                "2": "Monday",
                "3": "Tuesday",
                "4": "Wednesday",
                "5": "Thursday",
                "6": "Friday",
                "7": "Saturday"
            },
            "saved_prompt": "Campaign saved successfully"
        },
        "user_mapping": {
            "title": "Campaign agents",
            "mark_team_description": "Select <br/>all the team"
        },
        "import_from_campaign": "Import fields from other campaign",
        "back": "Back to campaigns"
    },
    "call_settings": {
        "red_subtitle": "Set warning time",
        "red_description": "* After how much time - the field will be red",
        "red_time_call": "Call time:",
        "red_hold_call": "Hold time:",
        "red_without_call": "Idle - no call:",
        "red_mute_call": "Muted:",
        "reasons_subtitle": "Callbacks and end reasons",
        "reasons_description": "Auto select after call attemp",
        "busy_continue_reason": "Callback - busy",
        "busy_end_reason": "End process - busy",
        "noresponse_continue_reason": "Callback - no answer",
        "noresponse_end_reason": "End process - no answer",
        "wrongnumber_end_reason": "End process - wrong number",
        "answered_continue_reason": "Callback - call answered",
        "answered_end_reason": "End process - call answered",
        "saved_prompt": "Settings saved successfully"
    },
    "permissions": {
        "admin": "Admin",
        "representative": "Agent",
        "edit_general_settings": "Edit global settings",
        "delete_contact": "Contacts - delete",
        "delete_project": "Projects - delete",
        "edit_project": "Projects - edit",
        "new_project": "Projects - create",
        "delete_role": "Roles - delete",
        "edit_role": "Roles - edit",
        "new_role": "ROles - create",
        "delete_team": "Teams - delete",
        "edit_team": "Teams - edit",
        "new_team": "Teams - create",
        "delete_user": "Users - delete",
        "edit_user": "Users - edit",
        "new_user": "Users - create",
        "delete_lead_provider": "Leads provider - delete",
        "edit_lead_provider": "Leads provider - edit",
        "new_lead_provider": "Leads provider - create",
        "leads": "Leads - view",
        "assign_leads": "Leads - assign",
        "delete_leads": "Leads - delete",
        "recordings_client": "Recordings client",
        "recordings_admin": "Recordings admin",
        "recordings_stream": "Recordings direct access",
        "reports_live_listening": "Reports - live listening",
        "reports_live_screen_monitor": "Reports - live screen monitor",
        "reports_call_sessions": "Reports - events",
        "reports_realtime_userinfo": "Reports - realtime agents",
        "reports_userinfo": "Reports - agents",
        "reports_call_history": "Reports - call history",
        "reports_orders": "Reports - orders"
    },
    "roles_list": {
        "title": "Roles management",
        "new_role": "New role",
        "columns": {
            "description": "Description",
            "name": "Name ",
            "actions": "Actions"
        },
        "delete_role_prompt": "Are you sure you want to delete this role?\nThis action will delete all data associated with this role"
    },
    "role_details": {
        "new_role": "New role",
        "role_list": "Roles list",
        "description": "Description",
        "name": "Internal name: <sup>(Unique, does not change)</sup>",
        "manage_permissions": "Permission management:",
        "saved_prompt": "Role saved successfully"
    },
    "teams_list": {
        "title": "Teams management",
        "new_team": "New team",
        "columns": {
            "name": "Name",
            "heads": "Team managers",
            "status": "Team status",
            "link": "Project assignment",
            "actions": "Actions"
        },
        "delete_team_prompt": "Are you sure you want to delete this team?\nThis action will delete all data associated"
    },
    "team_tabbed_area": {
        "team_list": "Team list",
        "edit_title": "Edit team",
        "new_title": "New team",
        "general": "General",
        "users": "Agents"
    },
    "team_details": {
        "title": "General settings",
        "team_name": "Team name:",
        "team_project": "Project assignment:",
        "team_heads": "Team managers:",
        "add_team_heads_button": "Add team manager",
        "saved_prompt": "The team saved successfully"
    },
    "team_users": {
        "title": "Team's agents",
        "team_name": "Team name:",
        "add_team_users_button": "Add agent",
        "saved_prompt": "The team saved successfully"
    },
    "users_list": {
        "title": "User management",
        "new_user": "New user",
        'import_users': 'Import',
        "columns": {
            "first_name": "First name",
            "last_name": "Last name",
            "role": "Role",
            "username": "Username",
            'project_name': 'Project',
            "password": "Password:",
            "last_phone_extension": "Last phone extension",
            "job_start_date": "Start job date",
            "team": "Team",
            "is_active": "Status",
            "actions": "Actions"
        },
        "delete_user_prompt": "Are you sure you want to delete this user?\nThis action will delete all the data associated with this user"
    },
    "user_details": {
        "new_user": "New user",
        "user_list": "User list",
        "user_details": "User details",
        "personal_details": "Personal details",
        "general_details": "General details",
        "username": "Username:",
        "password": "Password:",
        "role": "Role:",
        "team": "Team:",
        "project": "Project:",
        "status": "Status:",
        "first_name": "First name:",
        "last_name": "Last name:",
        "idt": "ID num:",
        "birthdate": "Birth date:",
        "gender": "Gender:",
        "address": "Address:",
        "phone": "Phone:",
        "phone2": "Phone 2:",
        "work_email": "Work email:",
        "job_start": "Job start date:",
        "job_end": "Job end date:",
        "clock_number": "Attendance Id:",
        "hourly_rate": "Hourly rate:",
        "phone_extension": "Phone extension:",
        "last_phone_extension": "Last phone extension:",
        "personal_break_minutes": "Total minutes for personal break:",
        "comment": "Comment:",
        "recordings_access": {
            "title": "Recordings access",
            "add": "Add access",
            "from_channel": "From extension:",
            "to_channel": "To extension:",
            "userfield": "userfield:",
            "from_date": "From date:",
            "to_date": "To date:"
        },
        "user_statuses": {
            "active": "Active",
            "inactive": "Inactive"
        },
        "saved_prompt": "The user saved successfully"
    },
    "continue_reasons": {
        "title": "Callback reasons",
        "add_row_button": "Add reason",
        "saved_prompt": "The reasons saved successfully"
    },
    "end_reasons": {
        "title": "End process reasons",
        "add_row_button": "Add reason",
        "saved_prompt": "The reasons saved successfully"
    },
    "generic_prompts": {
        "confirm_leave_unsaved": "Do you want to leave this screen and cancel all unsaved changes?"
    },
    "custom_fields": {
        "title_edit": "Edit field",
        "title_new": "New field",
        "field_types": {
            "text": "Text field",
            "multiline": "Multi line",
            "checkbox": "Yes / No",
            "checkboxlist": "Multiple checkbox",
            "radio": "Radio - single selection",
            "dropdown": "Dropdown box"
        },
        "custom_field_subtype": {
            "plain": "Plain",
            "date": "Date",
            "tel": "Phone"
        },
        "row_labels": {
            "required": "Required:",
            'readonly': 'Read only:',
            "name": "Field name:",
            "explain": "Explain: <i>Not required</i>",
            "subtype": "Field type:",
            "contact_source_field": "Contact field to pull:",
            "options": "Options:"
        },
        "group_basic_fields": "Basic fields",
        "group_custom_fields": "Dynamic fields",
        "add_option_button": "Add option"
    },
    "project_contact_fields": {
        "title": "Dynamic fields for contacts",
        "add_field_button": "Add field",
        "saved_prompt": "The fields saved successfully"
    },
    "product_order_fields": {
        "title": "Dynamic fields for orders",
        "add_field_button": "Add field",
        "saved_prompt": "The fields saved successfully",
        "copyable": "Save on copy:"
    },
    "products_list": {
        "title": "Product list",
        "new_product": "New product",
        "columns": {
            "id": "Product Id",
            "name": "Name",
            'is_active': 'Is Active',
            "created_at": "Created at",
            "updated_at": "Updated at",
            "actions": "Actions"
        },
        "delete_product_prompt": "Are you sure you want to delete this product?\nAll data associated will be deleted, include orders, etc"
    },
    "product_details": {
        "title_new": "New product",
        "title_edit": "Edit product",
        "product_name": "Product name:",
        'is_active': 'Is Active:',
        "saved_prompt": "The product saved successfully"
    },
    "campaigns_list": {
        "title": "Campaign list",
        "new_campaign": "New campaign",
        "exclusive": "Exclusive",
        "columns": {
            "name": "Name",
            "priority": "Priority",
            "status": "Status",
            "mode": "Mode",
            "teams": "Team",
            "created_at": "Created at",
            "updated_at": "Updated at",
            "actions": "Actions"
        },
        "delete_campaign_prompt": "Are you sure you want to delete this campaign?\nThis action will delete all related data"
    },
    "contact_list": {
        "title": "Contact list",
        "new_contact": "New contact",
        "export_to_campaign": "Assign <small>(current filtered)</small> contacts to campaign <br/>",
        "import_data": "Import contacts",
        "details": "Details",
        "columns": {
            "campaign_name": "Campaign",
            "created_at": "Created at",
            "updated_at": "Updated at",
            "is_active": "Is active?",
            "actions": "Actions",
            "campaign_comment": "Last call notes",
            "campaign_continue_reason": "Last callback reason",
            "campaign_end_reason": "Last end process reason",
            "campaign_next_action": "Next action",
            'campaign_next_action_when': 'Next action date',
            "campaign_continue_by": "Callback by",
            "campaign_answered_call_count": "Answered call count",
            'call_session_last_start_time': 'Last call session date',
            'call_session_user': 'Last call session user',
        },
        "delete_contact_prompt": "Are you sure you want to delete this contact?\nThis action will delete all associated data "
    },
    "new_edit_contact": {
        "new_title": "New contact",
        "view_title": "Contact details"
    },
    "import_contacts_page": {
        "title": "Import contacts",
        "title_2nd_phase": "Import and errors report",
        "import_button": "Generate import report >",
        "import_status_zero": "Analyzing import data...",
        "import_status": "Analyzing import data... ({{count}})",
        "action_cancel_import": "Cancel import process",
        "action_continue_import": "Import >",
        "settings_title": "Fields update settings",
        "settings_field": "Field",
        "settings_add": "Add",
        "settings_update": "Update",
        "settings_delete": "Delete",
        "status_errors": "Errors",
        "status_duplicates": "Duplicates",
        "status_new": "New",
        "status_total": "Total",
        "status_pending": "Pending:",
        "status_selected": "Selected:",
        "status_imported": "Imported:",
        "tab_errors": "Errors",
        "tab_duplicates": "Duplicates",
        "tab_new": "New",
        "tab_imported": "Imported",
        'tab_importedDuplicates': 'Local Duplicates',
        "tab_action_select": "Select",
        "tab_errors_column": "Errors",
        "error_tab_reasons": {
            "unknown": "Unknown",
            'too_long': 'Field too long',
            "duplicate": "Duplicate",
            "missing_phone_or_email": "Missing phone or Email",
            "missing_basic_info": "Missing basic info"
        },
        "error_generic_failure": "Import process failed for unknown reason.",
        'error_no_contacts': 'Import process failed, no contacts found to import.',
        'warn_imported_duplicates': 'Found additional {{number}} duplicates in the current records.',
        'completed_prompt': 'The process completed, {{count}} contacts imported.'

    },
    'select_import_template': {
        'ignore_duplicates': 'Ignore duplicates',
        "template_select": "Select template",
        "new_template": "New template",
        "edit_template": "View / Edit",
        'delete_template': 'Delete template',
        'delete_template_prompt': 'Are you sure you want to delete this template?',
        "import_file": "Select file to import",
    },
    "edit_import_template_popup": {
        "new_title": "New template",
        "edit_title": "Edit template",
        "name": "Template name",
        "load_file_label": "Load sample from existing file",
        "label": "Label from file",
        "sample_value": "Value sample",
        "field": "Map to field",
        "format": "Format",
        "saved_prompt": "The template saved successfully"
    },
    "file_controls": {
        "file_choose": {
            "m": "Select file...",
            "f": "Select file..."
        },
        "drop_file_description": {
            "male": "Release the file here...",
            "female": "Release the file here..."
        }
    },
    "lead_providers_list": {
        "title": "Leads providers and templates",
        "new_lead_provider": "New lead provider",
        "columns": {
            "id": "Id",
            "name": "Name",
            "project": "Project",
            "campaign": "Campaign",
            "email_address": "Email",
            "is_active": "Is active?",
            "actions": "Actions"
        },
        "delete_provider_prompt": "Are you sure you want to delete this lead provider?\nThis action will delete all associated data, includes leads, etc\nContacts that were created from thous leads will not be deleted."
    },
    "lead_provider_details": {
        "title_edit": "Edit lead provider",
        "title_new": "New lead provider",
        "name": "Provider name:",
        "project": "Assigned to project:",
        "campaign": "Assigned to campaign:",
        "campaign_none": "No campaign (Inactive)",
        "email_address": "Emails: (Semicolon separated)",
        "status": "Status:",
        "fields": "Fields:",
        "fields_pre": "String before:",
        "fields_suf": "String after:",
        "fields_contact_dest_field": "Mapped to field:",
        "fields_add_row": "Add row:",
        "lead_provider_statuses": {
            "active": "Active",
            "inactive": "Inactive"
        },
        "saved_prompt": "The lead provider saved successfully"
    },
    "leads_list": {
        "new": "New leads",
        "error": "Leads with errors",
        "assigned": "Assigned leads",
        "inprogress": "In progress leads",
        "done": "Closed leads",
        "tab_new": "New",
        "tab_error": "Errors",
        "tab_assigned": "Assigned",
        "tab_inprogress": "In progress",
        "tab_done": "Done",
        "columns": {
            "created_at": "Created at",
            "assigned_at": "Assigned at",
            "updated_at": "Updated at",
            "from": "From",
            "lead_provider": "Provider",
            "project": "Project",
            "campaign": "Campaign",
            "errors": "Errors",
            "assigned": "Assigned to agent",
            "actions": {
                "title": "Actions",
                "contact_info_title": "Contact card",
                "more_details": "More details",
                "assign": "Assignment",
                "add": "Add"
            }
        },
        "delete_lead_prompt": "Are you sure you want to delete this lead?\nThis action will delete all associated data.",
        "added_lead_prompt": "The lead added successfully",
        "errors_column_format": "t(\"leads_list.errors_column_format_leads\", {\"count\": {{leads_count}}, \"contacts_count\": {{contacts_count}}})",
        "errors_column_format_leads_zero": "t(\"leads_list.errors_column_format_contacts\", {\"count\": {{contacts_count}}})",
        "errors_column_format_leads": "t(\"leads_list.errors_column_format_leads_contacts\", {\"leads_count\": {{count}}, \"count\": {{contacts_count}}})",
        "errors_column_format_leads_contacts_zero": "{{leads_count}} Duplicate leads",
        "errors_column_format_leads_contacts": "{{leads_count}} Duplicate leads, {{count}} Duplicate contacts\n",
        "errors_column_format_contacts_zero": "errors_column_format_contacts_zero",
        "errors_column_format_contacts": "{{count}} Duplicate contacts",
        "error_duplicate_against_format": "{{record_type}} t(\"leads_list.duplicate\", {\"gender\": \"{{record_type_gender}}\"}) against {{field}} num {{record_id}}\n",
        "error_record_type_lead": [
            "Lead"
        ],
        "error_record_type_contact": [
            "Contact"
        ],
        "duplicate": {
            "m": "Duplicate",
            "f": "Duplicate"
        }
    },
    "lead_details": {
        "title": "Lead details"
    },
    "lead_manual_entry_page": {
        "title": "Manual lead",
        "team": "Team",
        "user": "Agent",
        "campaign": "Campaign",
        "saved_prompt": "The lead added successfully"
    },
    "assign_lead_popup": {
        "title": "Lead assignment",
        "columns": {
            "name": "Name",
            "count_leads": "Assigned leads today",
            "assign": "Assign"
        },
        "assign_action": "Assign >",
        "saved_prompt": "The assignment completed successfully!"
    },
    "contact_reassign_options_popup": {
        "title": "Handle assigned contact",
        "title_count": "Handle {{count}} assigned contacts",
        "ignore_conflict_and_reassign": "Ignore current process and reassign",
        "end_reason_reassign": "End current process",
        "end_reason": "End process reason",
        "contact_name": "Contact name",
        "campaign_name": "Campaign name:"
    },
    "export_to_campaign_popup": {
        "title": "Assign contacts to campaign",
        "new": "New campaign",
        "existing": "Existing campaign",
        "campaign_name_placeholder": "Campaign name",
        "saved_prompt": "Campaign assignment completed successfully."
    },
    "contact_popup": {
        "title_format": "<span>Contact card:</span> <b>{{name}}</b>",
        "title_new": "New contact",
        "tab_profile": "Contact detrails",
        "tab_lead": "Lead details",
        "tab_call_history": "Call history",
        "tab_orders": "Orders",
        "contact": {
            "title": "Contact details"
        },
        "call_history": {
            "title": "Call history",
            "type": "Type",
            "date": "Date",
            "time": "Time",
            "project": "Project",
            "campaign": "Campaign",
            "user": "Agent",
            "action": "Action",
            "reason": "Details",
            "comment": "Notes"
        },
        "last_orders": {
            "title": "Sales report",
            "date": "Date",
            "time": "Time",
            "user": "Agent",
            "campaign": "Campaign",
            "product": "Product",
            "order": "Order num",
            "status": "Status",
            "comment": "Notes"
        }
    },
    "campaign_status": {
        "active": "Active",
        "inactive": "Inactive",
        "returns_only": "Callbacks only",
        "new_only": "New contacts only"
    },
    "campaign_mode": {
        "outgoing": "Outgoing",
        "incoming": "Incoming",
        "outgoing_incoming": "Outgoing and Incoming",
        "voice_broadcast": "Voice Broadcast"
    },
    "time_units": {
        "hours": "Hours",
        "minutes": "Minutes",
        "seconds": "Seconds"
    },
    "import_from_entity_popup": {
        "name": "Name",
        "actions": "Actions",
        "import": "Select for import"
    },
    "call_events_report": {
        "title": "Call events report",
        'join_contact_fields': 'Export all basic fields',
        'only_last': 'Show only last event',
        "filters": {
            "type": "Event type",
            "status": "Status",
            "contact_phones": "Contact phone",
            "dialed_phone": "Dialed phone",
            "contact_id": "Contact Id",
            "session_id": "Session Id"
        },
        "type_options": {
            "outgoing": "Outgoing Call",
            "initiated": "Initiated Call",
            'predictive': 'Predictive Call',
            'incoming': 'Incoming Call',
            "override": "Override"
        },
        "status_options": {
            "inprogress": "In progress",
            "ended": "Ended"
        },
        "field_labels": {
            "campaign": "Campaign:",
            "start_time": "Start at:",
            "end_time": "End at:",
            "contact": "Contact:",
            "user": "Agent:",
            "type": "Type:",
            "status": "Status:",
            "continue_reason": "Callback reason:",
            "continue_by": "Callback by:",
            "end_reason": "End process reason:",
            "comment": "Notes:"
        },
        "columns": {
            "contact_id": "Contact Id",
            "contact": "Contact",
            "campaign_name": "Campaign",
            "user": "Agent",
            "team": "Team",
            "start_time": "Start at",
            "end_time": "End at",
            "type": "Type:",
            "status": "Status",
            "continue_reason_name": "Callback reason",
            "continue_by": "Callback by",
            "end_reason_name": "End process reason",
            "comment": "Notes"
        },
        "recordings": {
            "title": "Calls in session:"
        },
        "sum_area": {
            "title": "Sessions summary by current filter:"
        }
    },
    "realtime_userinfo_report": {
        "title": "Realtime agent report",
        "connection_close": "Server connection disconnected.\nDo you want to reconnect?",
        "connection_close_error": "Server connection disconnected because: {{error}}\nDo you want to reconnect?",
        "show_offline": "Show offline",
        "columns": {
            "user_fullname": "Agent name",
            "username": "Username",
            "team_name": "Team",
            "status": "Call status",
            "status_duration": "Status duration",
            "call_count": "Total calls",
            "answered_call_count": "Total answered calls",
            "saved_sessions": "Saved sessions",
            "closed_orders": "Total orders",
            "gross_call_duration": "Total call duration",
            "call_duration_avg": "Average call duration",
            "personal_break_duration": "Personal break duration",
            "logged_in_duration": "Total logged in time"
        },
        "statuses": {
            "logged_out": "Logged out",
            "personal_break": "Personal break",
            "official_break": "Official break",
            "idle": "Idle",
            "dialing": "Dialing...",
            "in_call": "In call",
            "override": "Override"
        },
        "context_actions": {
            "live_listening": "Live listening",
            "live_screen_monitor": "Live screen monitor",
            "personal_break": "Activate personal break",
            "official_break": "Activate official break",
            "stop_break": "Stop break",
            "logout": "Force Log out"
        }
    },
    "userinfo_report": {
        "title": "Daily agent report",
        "columns": {
            'user_id': 'User ID',
            "user_fullname": "Agent name",
            "username": "Username",
            "team_name": "Team",
            "status": "Call status",
            "status_duration": "Status duration",
            "call_count": "Total calls",
            "answered_call_count": "Total answered calls",
            "saved_sessions": "Saved sessions",
            "closed_orders": "Total orders",
            "gross_call_duration": "Total call duration",
            "net_call_duration": "Total talk duration",
            "call_duration_avg": "Average call duration",
            "personal_break_duration": "Personal break duration",
            "logged_in_duration": "Total logged in time"
        }
    },
    "call_history_report": {
        "title": "Call history report",
        "filters": {
            "start_time": "Start at",
            "status": "Status",
            "gross_duration": "Call duration",
            "net_duration": "Talk duration"
        },
        "columns": {
            "user_fullname": "Agent",
            "start_time": "Start at",
            "team_name": "Team",
            "status": "Call status",
            "gross_duration": "Call duration",
            "net_duration": "Talk duration",
            "call_session_id": "Session Id",
            "phone": "Phone",
            "channel": "Extension",
            "actions": "Actions",
            "play_record": "Play recording",
            "play_record_button": "Play"
        }
    },
    "orders_report": {
        "title": "Orders report",
        "columns": {
            "id": "Order ID",
            "campaign_name": "Campaign",
            "contact_name": "Contact",
            "status": "Order status",
            "created_at": "Created at",
            "created_by": "Created by",
            "updated_at": "Updated at",
            "closed_at": "Closed at",
            "closed_by": "Closed by",
            "closed_by_team_name": "Closed by team",
            "actions": "Actions"
        }
    },

    'campaigns_report': {
        'title': 'Campaigns Status',
        'select_project': 'Project:',
        'no_campaigns_message': 'No campaigns in this project, Please select different project.',
        'counted_continue_reason': 'Callback reason to count:',
        'campaign_name': 'Campaign Name',
        'contacts': 'Contacts in campaign',
        'next_action_call': 'Waiting for first action',
        'next_action_continue': 'Callbacks',
        'next_action_end': 'Ended',
        'total_to_call': 'To call',
        'continue_reason': 'Continue reason',
        'contacted': 'Contacted',
        'call_sessions': 'Call Sessions',
        'one_call': 'One call session',
        '2_calls': '2 call Sessions',
        '3_calls_or_more': '3 call Sessions or more',
    },

    "yes_no_options": {
        "true": "Yes",
        "false": "No"
    },
    "default_alert_title": "CenterPoint",
    "empty_screen_message": "To generate report please use \"Add filter\" button",
    "choose_dates_filter_screen_message": "Call date is required field.\nPlease add it by clicking \"Add filter\"",
    "only_one_date_filter_screen_message": "Only single day filter is allowed, please remove the unnecessary",
    "reload_after_filter_screen_message": "Click \"refresh\" button to reload data by current filters.",
    "total_record_count_label": "Total records",
    "yes": "Yes",
    "no": "No",
    "cancel": "Cancel",
    "ok": "OK",
    "save": "Save",
    "edit": "Edit",
    "cancel_edit": "Cancel edit",
    "delete": "Delete",
    "none": "None",
    "refresh": "Refresh"
}, {
    plural: function (count) {
        if (count === 0) return 'zero';
        if (count === 1) return 'one';
        return 'plural';
    }
}
];
